'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { signOut } from 'next-auth/react';
import { useEffect } from 'react';

import { MobileFirstAppLayout } from '@/component/layout/MobileFirstAppLayout/MobileFirstAppLayout';
import { Column } from '@/component/parts/layout/Column/Column';
import { Spinner } from '@/component/parts/placeholder/Spinner/Spinner';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      throwOnError: true,
    },
  },
});

function Page() {
  useEffect(() => {
    const signOutPromise = signOut({
      redirect: true,
      callbackUrl: '/redirect',
    });
    return () => {
      signOutPromise
        .then((_) => {
          // Promise completed, no cleanup needed
        })
        .catch(() => {
          // Promise rejected, no cleanup needed
        });
    };
  }, []);

  return (
    <MobileFirstAppLayout>
      <Column spacing="30px">
        <Spinner />
      </Column>
    </MobileFirstAppLayout>
  );
}

export function UnauthorizedPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <Page />
    </QueryClientProvider>
  );
}
